import create from 'zustand'

export const calculatorStore = create(set => ({
  selectedOptions: [],
  addOption: (option) => set(state => ({ selectedOptions: [...state.selectedOptions, option] })),
  removeOption: (option) => set(state => ({ selectedOptions: state.selectedOptions.filter(opt => opt.name !== option.name) })),
}))